var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "riSearchBox" },
    [
      _c("h2", { staticClass: "riSearchBox__header" }, [
        _vm._v("Willkommen im Serviceportal")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "riSearchBox__subheader" }, [
        _vm._v(
          "\n\t\tSie befinden sich auf der Startseite. Von hier geht es zu den Angeboten der Verwaltung und IT.SERVICES, die für Beschäftigte wichtig sind.\n\t"
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "riSearchBox__searchControl",
          on: { click: _vm.toggleOverlay }
        },
        [
          _c("SearchControl", {
            attrs: { placeholder: "Serviceportal durchsuchen" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.showOverlay
        ? [
            _c("div", { staticClass: "riSearchBoxOverlay" }, [
              _c("div", { staticClass: "riSearchBoxOverlayContent" }, [
                _c("div", { staticClass: "header" }, [
                  _c("div", { staticClass: "logo" }, [
                    _c("img", { attrs: { src: _vm.logoUrl, alt: "logo" } })
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "close", on: { click: _vm.toggleOverlay } },
                    [_c("CloseIcon")],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "content" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "searchInput" },
                    [
                      _c("SearchControl", {
                        attrs: {
                          accented: true,
                          placeholder: "Suchbegriff eingeben"
                        },
                        on: { search: _vm.search }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "searchSuggestions" }, [
                    _c("h3", { staticClass: "searchSuggestions__header" }, [
                      _vm._v("Vorschläge")
                    ]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "searchSuggestions__suggestions" },
                      _vm._l(_vm.searchSuggestions, function(suggestion, idx) {
                        return _c("SearchTag", {
                          key: idx,
                          attrs: { label: suggestion.label },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              _vm.search(suggestion.label)
                            }
                          }
                        })
                      })
                    )
                  ])
                ])
              ])
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "searchLabel" }, [
      _c("h2", [
        _vm._v("\n\t\t\t\t\t\t\tIch suche"),
        _c("br"),
        _vm._v("\n\t\t\t\t\t\t\tInformation zu:\n\t\t\t\t\t\t")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }